import { graphql } from 'react-relay';
import { postStatusUpdater } from '../updaters.utils';
import { genericMutation } from '../utils';
import type { Hub_Create_Mutation, Hub_Delete_Mutation } from './Hub.mutation';
import type { Hub_Duplicate_Mutation } from './__generated__/Hub_Duplicate_Mutation.graphql';
import type { Hub_Update_Mutation } from './__generated__/Hub_Update_Mutation.graphql';

const UpdateHubMutation = graphql`
  mutation Hub_Update_Mutation($input: UpdateHubInput!) {
    updateHub(input: $input) {
      hub {
        ...Hub_Fragment @relay(mask: false)
      }
    }
  }
`;

export const updateHubMutation = genericMutation<Hub_Update_Mutation>({
  mutation: UpdateHubMutation,
  updater: (store, data) => {
    if (!data?.updateHub?.hub?.id || !data?.updateHub?.hub?.status) return;
    postStatusUpdater(store, [data?.updateHub?.hub?.id], 'Hub', data?.updateHub?.hub?.status);
  },
});

export type {
  Hub_Create_Mutation,
  Hub_Create_Mutation$data,
  Hub_Create_Mutation$variables,
} from './__generated__/Hub_Create_Mutation.graphql';
const CreateHubMutation = graphql`
  mutation Hub_Create_Mutation(
    $input: CreateHubInput!
    $connections: [ID!]! # needed for @prependNode directive
  ) {
    createHub(input: $input) {
      hub @prependNode(connections: $connections, edgeTypeName: "HubPage") {
        id
        title
        status
        modified
        slug
        author {
          ...Frags_Wiz_Author_Fragment @relay(mask: false)
        }
      }
    }
  }
`;

export const createHubMutation = genericMutation<Hub_Create_Mutation>({
  mutation: CreateHubMutation,
});

const DuplicateHubMutation = graphql`
  mutation Hub_Duplicate_Mutation(
    $input: DuplicateHubInput!
    $connections: [ID!]! # needed for @prependNode directive
  ) {
    duplicateHub(input: $input) {
      hub @prependNode(connections: $connections, edgeTypeName: "HubPage") {
        id
        title
        status
        modified
        slug
        author {
          ...Frags_Wiz_Author_Fragment @relay(mask: false)
        }
      }
    }
  }
`;

export const duplicateHubMutation = genericMutation<Hub_Duplicate_Mutation>({
  mutation: DuplicateHubMutation,
});

export type {
  Hub_Delete_Mutation,
  Hub_Delete_Mutation$data,
  Hub_Delete_Mutation$variables,
} from './__generated__/Hub_Delete_Mutation.graphql';
export const DeleteHubMutation = graphql`
  mutation Hub_Delete_Mutation($input: DeleteHubInput!) @raw_response_type {
    deleteHub(input: $input) {
      deletedId @deleteRecord
    }
  }
`;

export const deleteHubMutation = genericMutation<Hub_Delete_Mutation>(({ input }) => ({
  mutation: DeleteHubMutation,
  optimisticResponse: {
    deleteHub: {
      deletedId: input.id,
    },
  },
}));
